import PublicApiModel from './globals/PublicApiModel';

export default class LoginCheckModel extends PublicApiModel {
  static get path() {
    return '/backend/external/login_check';
  }
}
